import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';
import { GestionarFamiliaSrRestImplService } from './api/gestionarFamiliaSrRestImpl.service';
import { BASE_PATH } from './variables';



@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    GestionarFamiliaSrRestImplService,
    {
      provide: BASE_PATH,
      useValue: 'http://127.0.0.1:4010'
    }
  ]
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
    return {
      ngModule: ApiModule,
      providers: [ {provide: Configuration, useFactory: configurationFactory} ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule,
              @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
        'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
